import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import TextSlider from './components/TextSlider';
import { ArrowRightOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { RecoilRoot } from "recoil";
import { useRecoilState } from 'recoil';
import { _isloadinginitial, _homepagedata } from './RecoilState';
import './index.css';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Link } from "react-router-dom";
import App from './App';
import Footer from './components/Footer';
import Header from './components/Header';
import Programs from './pages/Programs';
import ProgramLanding from './pages/ProgramLanding';
import YanchaKids from './pages/YanchaKids';
import YanchaKidsInitiation from './pages/YanchaKidsInitiation';
import OneonOneSession from './pages/OneonOneSession';
import YanchaWonderGame from './pages/YanchaWonderGame';
import ProgramDetails from './pages/ProgramDetails';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CorporateOfferings from './pages/CorporateOfferings';
import About from './pages/About';
import YanchaSurvey from './pages/YanchaSurvey';
import Jido from './pages/Jido';
import Nudges from './pages/Nudges';
import { App as CapacitorApp } from '@capacitor/app';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Toast } from '@capacitor/toast';
import StoryOfLife from './storyoflife/StoryOfLife';
import AllResults from './storyoflife/AllResults';
import ServerResult from './storyoflife/ServerResult';
import CareerQuiz from './careerquiz/CareerQuiz';
import CareerQuizComplete from './careerquiz/CareerQuizComplete';

axios.defaults.baseURL = 'https://yanchacms.metadei.in/wp-json/wp/v2';

const Main = () => {
    const [isloading, setisLoading] = useRecoilState(_isloadinginitial);
    const [homepagedata, setHomepagedata] = useRecoilState(_homepagedata);
    const [isspin, setisSpin] = useState(true);
    const [lastBackPress, setLastBackPress] = useState(0);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [showInstallMessage, setShowInstallMessage] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const toAbout = () => {
        setisSpin(false);
        navigate('/about');
    };

    useEffect(() => {
        downloadHomepagedata();
        setTimeout(() => {
            setisLoading(false);
        }, 3000);

        const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

        setIsIOS(isIOSDevice);
        if (isIOSDevice && !isStandalone) {
            setShowInstallMessage(true);
        }
    }, []);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the install prompt');
                } else {
                    console.log('User dismissed the install prompt');
                }
                setDeferredPrompt(null);
                setIsInstallable(false);
            });
        }
    };

    const downloadHomepagedata = () => {
        axios.get('pages/18?acf_format=standard')
            .then((response) => {
                setHomepagedata(response.data.acf);
            });
    };

    const showToast = async (message) => {
        await Toast.show({
            text: message,
            duration: 'short'
        });
    };

    const handleBackButton = () => {
        const now = Date.now();
        if (now - lastBackPress < 500) {  // 300ms for double-tap detection
            CapacitorApp.exitApp();
        } else {
            setLastBackPress(now);
            if (location.pathname !== '/') {
                window.history.back();
            } else {
                showToast("Press back twice to exit");
                Haptics.impact({ style: ImpactStyle.Light });
            }
        }
    };

    useEffect(() => {
        CapacitorApp.addListener('backButton', handleBackButton);

        return () => {
            CapacitorApp.removeAllListeners();
        };
    }, [lastBackPress]);

    const Splash = () => {
        const sliderText = [
            {
                heading: "Help your child shine! Grades aren’t everything.",
                body: "Are you focusing on developing your child's mindsets, beliefs, strengths instead of just their grades?",
                icon: "https://utfs.io/f/2e12f418-4985-4659-b0fc-762c98458dba-1t4zfv.png"
            },
            {
                heading: "Help your child overcome fears.",
                body: "Are you supporting your child in getting over their fears, rather than inducing them?",
                icon: "https://utfs.io/f/31a38dec-e964-4094-9d54-7eb7358fdf5b-1v9yo.png"
            },
            {
                heading: "Your child learns from you.",
                body: "Are you modeling behaviors you want your child to learn? Are you reading, exploring, and discovering?",
                icon: "https://utfs.io/f/46f62464-775c-433c-8f24-9b088d48bd0d-1p8chw.png"
            },
            {
                heading: "Are you nurturing your child’s potential?",
                body: "Are you focusing on evolving your child’s capabilities rather than just providing as a parent?",
                icon: "https://utfs.io/f/098eb142-2b8c-4c40-a680-57b36c7f10ae-wzz729.png"
            }
        ];

        return (
            <div className='px-[10px] pt-[20px]'>
                <div className="flex flex-col">
                    <div className='h-auto flex flex-col items-center'>
                        <img src={require('./assets/yancha_pkt_logo.png')} width={225} alt="yancha" />
                        <h3 className="brand-color text-center txt-small medium-heading">An Award Winning, Research Driven, Innovative, Ed-Tech,
                            Next Gen Life Skills Learning Solutions</h3>
                    </div>
                    <div className='h-auto mt-[50px] spacer'>
                        <TextSlider slides={sliderText} />
                    </div>
                    <div className='text-center'>
                        <p className='brand-text gradient-heading bottom7px'>Why Yancha?</p>
                        <div className='brand-text txt-small bottom15px'>
                            <p>
                                Yancha is a Positive Parenting and Child Development Organization. We work with parents and help them raise their children well, thereby, empowering parents to transform their families, and become more effective in workplace.
                            </p>
                        </div>
                    </div>
                    <div className='h-auto pb-[10px] pt-[5px] ml-[-10px] w-full flex flex-col items-center absolute bottom-0 bg-white'>
                        {
                            isloading ?
                                <Spin />
                                :
                                <div>
                                    <div className='flex flex-row gap-5 bg-white mb-5 justify-center'>
                                        {/* story of life */}
                                        {/* <Link to="/story-of-life">
                                            <div className='flex flex-col items-center'>
                                                <img src={require('./assets/storyoflifelogo.png')} width={75} alt="programs" />
                                                <p className='brand-font text-[18px] text-center txt-bold'>Story Of Life</p>
                                            </div>
                                        </Link> */}

                                        {/* career */}
                                        {/* <Link to="/career-quiz">
                                            <div className='flex flex-col items-center'>
                                                <img src={require('./assets/goal.png')} width={75} alt="Career Quiz" />
                                                <p className='brand-font text-[18px] text-center txt-bold'>Crystal Report</p>
                                            </div>
                                        </Link> */}

                                        {/* jido */}
                                        {/* <Link to="/jido">
                                            <div className='flex flex-col items-center'>
                                                <img src={require('./assets/jido2.png')} width={75} alt="JIDO" />
                                                <p className='brand-font text-[18px] text-center txt-bold'>jido</p>
                                            </div>
                                        </Link> */}
                                    </div>

                                    <div className='flex flex-row gap-[5px] bg-white '>
                                        {isInstallable && !isIOS && (
                                            <button className='flex flex-row h-[50px] pl-[25px] pr-[25px] rounded-full border-solid border-[2px] border-[#92278F] gradient-small' onClick={handleInstallClick}>
                                                <p>Install</p><CloudDownloadOutlined />
                                            </button>
                                        )}
                                        {isIOS && showInstallMessage && (
                                            <div className="p-2 text-center">
                                                <p className="text-xs">To install, tap the Share button and then 'Add to Home Screen'.</p>
                                            </div>
                                        )}
                                        <button className='h-[50px] pl-[25px] pr-[25px] rounded-full border-solid border-[2px] border-[#92278F] gradient-small' onClick={() => toAbout()}>
                                            About Yancha
                                        </button>
                                        <button className='h-[50px] w-[50px] rounded-full border-solid border-[2px] border-[#92278F]' onClick={() => setisSpin(false)}>
                                            <ArrowRightOutlined />
                                        </button>
                                    </div>
                                </div>

                        }
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {isspin ? <Splash /> : (
                <>
                    <Header />
                    <div className='page-container'>
                        <Routes>
                            <Route path="/" element={<App />} key="home" />
                            <Route path="/programs" element={<Programs />} key="programs" />
                            <Route path="/programs/:pslug" element={<ProgramDetails />} key="program-details" />
                            <Route path="/yancha-kids" element={<YanchaKids />} key="kids" />
                            <Route path="/yancha-kids-initiation" element={<YanchaKidsInitiation />} key="kids_initiation" />
                            <Route path="/program-landing" element={<ProgramLanding />} key="program-landing" />
                            <Route path="/wonder-game" element={<YanchaWonderGame />} key="wonder-game" />
                            <Route path="/one-on-one" element={<OneonOneSession />} key="one-on-one" />
                            <Route path="/program-details" element={<ProgramDetails />} key="program-details" />
                            <Route path="/corporate/:cslug" element={<CorporateOfferings />} key="corporate-offerings" />
                            <Route path="/about" exact element={<About />} key="about" />
                            <Route path="/survey" element={<YanchaSurvey />} key="survey" />
                            <Route path="/jido" element={<Jido />} key="jido" />
                            <Route path="/nudges" element={<Nudges />} key="nudges" />
                            <Route path="/story-of-life" element={<StoryOfLife />} key="story-of-life" />
                            <Route path="/rzfabmfn" element={<AllResults />} key="story-of-life-all-results" />
                            <Route path="/rzfabmfn/:id" element={<ServerResult />} key="story-of-life-server-result" />
                            <Route path='/career-quiz' element={<CareerQuiz />} key="career-quiz" />
                            <Route path='/career-quiz-full' element={<CareerQuizComplete />} key="career-quiz-full" />
                        </Routes>
                    </div>
                    <Footer />
                </>
            )}
        </>
    );
};

ReactDOM.render(
    <RecoilRoot>
        <Router>
            <Main />
        </Router>
    </RecoilRoot>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
